import StaticSelectorList from 'components/UtilityComponents/SelectorList/StaticSelectorList';

export default function BranchManagerList({ selectorListState }) {
	const linkTo = '/managers/manage/';
	return (
		<StaticSelectorList
			label='MANAGERS'
			textFieldLabel='Manager'
			linkTo={linkTo}
			{...selectorListState}
		/>
	);
}
